<template>
    <ModalBasic
        :title="getFromDictionary(`list.modal.type.remove`, 'title')"
        :modal-open="state.modals.removeFromList.isOpen"
        @close-modal="state.modals.removeFromList.isOpen = false"
    >
        <div>
            <div class="px-5 py-4">
                <div class="text-sm">
                    <div class="mb-3">
                        <div class="my-4">
                            <p>
                                Are you sure you want to remove the
                                <span class="font-semibold">{{ $lodash.size(selectedCreators) }}</span> creators from
                                this list?
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="border-t border-slate-200 px-5 py-4">
                <div class="flex flex-wrap justify-end space-x-2">
                    <button
                        class="btn-sm border-slate-200 text-slate-600 hover:border-slate-300"
                        @click="state.modals.removeFromList.isOpen = false"
                    >
                        Cancel
                    </button>

                    <button class="btn-sm bg-rose-500 text-white hover:bg-rose-600" @click="onRemoveFromList">
                        Remove
                    </button>
                </div>
            </div>
        </div>
    </ModalBasic>

    <div class="rounded-sm border border-slate-200 bg-white h-full flex flex-col">

        <template v-if="showPreGenerationSlot">
            <slot name="pre-generation"></slot>
        </template>

        <template v-else>
            <header class="relative h-14 border-b border-slate-200 px-3">
                <div v-show="!$lodash.size(selectedCreators)" class="flex items-center gap-2 py-2.5 min-w-max">
                    <slot name="header-toolbar"></slot>

                    <div v-if="isSortable === true" class="relative mt-auto flex gap-2">
                        <DropdownMultiSort :sorts="paging.sort" :columns="sortColumns" @new-sorts="onNewSort">
                            <div class="flex">
                                <div
                                    class="btn flex cursor-pointer overflow-hidden rounded border-slate-200 bg-slate-50 uppercase shadow-none hover:border-slate-300 hover:bg-slate-100"
                                >
                                    <div class="flex">
                                        <AppIcon
                                            name="arrow-up-arrow-down"
                                            class="my-auto h-3.5 w-3.5"
                                        />
                                        <div class="ml-1.5 flex text-xs font-semibold">
                                            <span v-if="$lodash.size(paging.sort)"
                                                >{{ $lodash.size(paging.sort) }} sorts</span
                                            >
                                            <span v-else>Custom Sort</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </DropdownMultiSort>
                    </div>

                    <slot name="header-toolbar-filters"></slot>

                    <div class="flex-grow"></div>

                    <slot name="header-toolbar-right"></slot>

                    <!-- <div
                        v-if="isDevModeEnabled"
                        :class="{
                            'pointer-events-none opacity-50': !creators || creators.length === 0,
                        }"
                    >
                        <button class="btn-sm rounded bg-indigo-500 text-white hover:bg-indigo-600 py-1.5" @click="exportCreators">
                            <span v-if="!paging.totalRecords"> Export Top 1,000 </span>
                            <span v-else>
                                Export
                                {{
                                    paging.totalRecords > 5000
                                        ? $numeral(5000).format('0,0')
                                        : $numeral(paging.totalRecords).format('0,0')
                                }}
                                creators
                            </span>
                        </button>
                    </div> -->
                </div>

                <div v-if="$lodash.size(selectedCreators) > 0">
                    <div class="my-auto flex gap-2 px-2 py-3.5">
                        <div class="mr-1 flex cursor-pointer text-slate-500 hover:text-slate-900" @click="onOptionsClose">
                            <AppIcon name="xmark" class="my-auto h-4 w-4 shrink-0" />
                        </div>

                        <template v-if="selfActiveOrganization">
                            <button
                                class="btn btn-sm bg-indigo-500 text-white hover:bg-indigo-600"
                                @click="
                                    $store.commit('modal:setData', {
                                        modal_id: 'add_creator_to_modal',
                                        data: {
                                            is_open: true,
                                            platform_id: platformId,
                                            default_all_platforms: includeAllPlatformsByDefaultForList,
                                            superviews: $lodash.map(selectedCreators, superviewPath),
                                            creator_platforms: $lodash
                                                .chain(selectedCreators)
                                                .values()
                                                .flatMap((creator) => {

                                                    const creatorSuperview = $lodash.get(creator, superviewPath)

                                                    // Default profile for this creator
                                                    const defaultProfile = {
                                                        id: creatorSuperview?._id ?? creator?.id,
                                                        platform_id: creatorSuperview?.platform_id ?? creator?.platform_id,
                                                    }

                                                    // Get the possible profiles for this creator
                                                    const sources = [
                                                        creator?.source_ids,
                                                        Object.values(creatorSuperview?.normalized?.socials ?? {}),
                                                    ]

                                                    // Pick the first non-empty array
                                                    const profiles = sources.find((arr) => Array.isArray(arr) && arr.length) || []

                                                    // Only keep the first profile per platform_id for this creator
                                                    return $lodash.uniqBy([defaultProfile, ...profiles], 'platform_id')
                                                })
                                                .map(p => ({
                                                    id: p.platform_user_id ?? p.id,
                                                    platform_id: p.platform_id,
                                                }))
                                                .value(),
                                        },
                                    })
                                "
                            >
                                Add selected to... ({{ $lodash.size(selectedCreators) }})
                            </button>
                            <button
                                v-if="listId"
                                class="btn btn-sm bg-red-500 text-white hover:bg-red-600"
                                @click="state.modals.removeFromList.isOpen = true"
                            >
                                Remove Selected from list ({{ $lodash.size(selectedCreators) }})
                            </button>

                            <button
                                v-if="listId && checkPermission('module.messages')"
                                class="btn btn-sm bg-indigo-500 text-white hover:bg-indigo-600"
                                @click="onSendEmail"
                            >
                                Send email ({{ $lodash.size(selectedCreators) }})
                            </button>
                        </template>
                    </div>
                </div>
            </header>

            <div
                ref="tableWrapper"
                class="scrollbar-default grow overflow-auto overflow-y-auto bg-slate-50"
            >
                <table class="w-full table-auto">
                    <thead
                        class="sticky left-0 top-0 z-20 rounded-sm bg-slate-50 text-left"
                        :class="{
                            'pointer-events-none cursor-default': isLoading === true,
                        }"
                    >
                        <tr class="h-12">
                            <th
                                v-if="isSelectable"
                                class="sticky left-0 top-0 z-10 w-10 min-w-10 bg-slate-50 first:pl-5 last:pr-5"
                            >
                                <div v-if="isLoading === false" class="flex w-full">
                                    <input
                                        type="checkbox"
                                        class="form-checkbox my-auto"
                                        :checked="isAllPageCheckboxSelected"
                                        @click="onAllPageCheckboxClick"
                                    />
                                </div>
                            </th>
                            <th
                                v-for="column in visibleColumns"
                                :key="`header-column-${column.key}`"
                                class="group relative whitespace-nowrap p-0 first:pl-5 last:pr-5"
                                :class="{
                                    'sticky top-0 z-10 bg-slate-50 border-r border-slate-50': column?.is_sticky,
                                    'left-10': isSelectable && column?.is_sticky,
                                    [column?.header?.class]: !!column?.header?.class,
                                    'cursor-pointer hover:bg-slate-200':
                                        column.header.is_sortable === true || column.header.is_hideable !== false,
                                }"
                            >
                                <div
                                    :class="{
                                        'border-r border-slate-100': column?.is_sticky,
                                    }"
                                >
                                    <DropdownTableHeader
                                        :is-sortable="column.header.is_sortable"
                                        :is-hideable="column.header.is_hideable"
                                        :column-id="column.id"
                                        :sort-direction="sortLookup[column.id]"
                                        @action="onHeaderColumnAction"
                                    >
                                        <div class="flex flex-grow items-center whitespace-nowrap p-2">
                                            <Tooltip
                                                v-if="column.header.tooltip"
                                                class="mr-2 flex self-center"
                                                tooltip-trigger-class="flex items-center justify-center leading-none"
                                            >
                                                <template #trigger>
                                                    <AppIcon
                                                        class="h-4 w-4 text-slate-400 transition duration-200 hover:text-slate-500"
                                                        name="circle-info"
                                                    />
                                                </template>
                                                <template #default>
                                                    <div class="font-bold">
                                                        <h5 class="text-lg text-white">
                                                            {{ column.header.tooltip.title }}
                                                        </h5>
                                                        <div
                                                            v-if="column.header.sub_label"
                                                            class="mb-3 text-xs font-bold leading-none text-slate-200"
                                                        >
                                                            {{ column.header.tooltip.sub_title }}
                                                        </div>
                                                        <div class="space-y-2">
                                                            <p
                                                                v-for="(paragraph, index) in column.header.tooltip.content"
                                                                :key="`paragraph-${index}`"
                                                                class="text-xs text-slate-300"
                                                                :class="{
                                                                    [paragraph.class]: !!paragraph.class,
                                                                }"
                                                            >
                                                                {{ paragraph.text }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </template>
                                            </Tooltip>

                                            <div class="my-auto flex flex-col">
                                                <span class="text-xs font-semibold uppercase leading-none text-slate-500">
                                                    {{ column.header.label }}
                                                </span>
                                                <span
                                                    v-if="column.header.sub_label"
                                                    class="text-[10px] font-bold leading-none text-slate-400"
                                                >
                                                    {{ column.header.sub_label }}
                                                </span>
                                            </div>

                                            <div v-if="column.header.is_sortable" class="ml-auto flex">
                                                <div class="my-auto ml-2 flex flex-col">
                                                    <AppIcon
                                                        name="chevron-up"
                                                        class="-mb-1 h-2.5 w-2.5 opacity-25"
                                                        :class="{
                                                            'text-indigo-600 !opacity-100':
                                                                sortLookup[column.id] && sortLookup[column.id] === 'asc',
                                                            'group-hover:text-indigo-600 group-hover:!opacity-100':
                                                                sortLookup[column.id] && sortLookup[column.id] === 'desc',
                                                        }"
                                                    />

                                                    <AppIcon
                                                        name="chevron-down"
                                                        class="h-2.5 w-2.5 opacity-25 group-hover:text-slate-600 group-hover:!opacity-100"
                                                        :class="{
                                                            'text-indigo-600 !opacity-100':
                                                                sortLookup[column.id] && sortLookup[column.id] === 'desc',
                                                        }"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </DropdownTableHeader>

                                </div>
                            </th>
                        </tr>
                    </thead>

                    <tbody
                        v-if="isLoading === false"
                        class="text-sm"
                        :class="{
                            'pointer-events-none opacity-50': isBusy === true,
                        }"
                    >
                        <template v-if="creators.length">
                        <tr v-for="creator in creators" :key="creator[idProp]" class="group min-h-12 border-b border-slate-200">
                            <td
                                v-if="isSelectable"
                                class="sticky left-0 z-10 w-10 min-w-10 bg-white first:pl-5 last:pr-5 border-b border-slate-200"
                            >
                                <input
                                    :checked="selectedCreators[creator[idProp]]"
                                    type="checkbox"
                                    class="form-checkbox"
                                    :value="creator"
                                    @input="onSelectCreator(creator, $event)"
                                />
                            </td>

                            <td
                                v-for="column in visibleColumns"
                                :key="`body-column-${column.key}`"
                                class="whitespace-nowrap bg-white first:pl-5 last:pr-5 min-h-12"
                                :class="{
                                    'sticky z-10 border-b border-slate-200': column?.is_sticky,
                                    'left-10': isSelectable && column?.is_sticky,
                                    [column?.row?.class]: !!column?.row?.class,
                                }"
                            >
                                <div class="flex flex-col min-h-12 justify-center px-2" :class="column?.is_sticky ? `border-r border-slate-100`: ``">
                                    <template v-if="column?.row?.slot">
                                        <!-- If we have a slot transformer, apply it to the input, if not just fetch the value at key -->
                                        <slot
                                            :name="column.row.slot"
                                            v-bind="{
                                                item: creator,
                                                field: column.row.slotTransformer
                                                    ? column.row.slotTransformer(creator)
                                                    : $lodash.get(creator, column.key),
                                                column,
                                            }"
                                        />
                                    </template>

                                    <template v-else-if="column?.row?.formatter">
                                        {{
                                            column.row.formatter({
                                                item: creator,
                                                field: $lodash.get(creator, column.key),
                                                column,
                                            })
                                        }}
                                    </template>

                                    <template v-else>
                                        {{ $lodash.get(creator, column.key) }}
                                    </template>
                                </div>
                            </td>
                        </tr>
                        </template>
                        <tr v-else>
                            <td :colspan="visibleColumns.length + (isSelectable ? 1 : 0)" class="h-24 bg-white text-center text-sm text-slate-500">
                                No results to show
                            </td>
                        </tr>
                    </tbody>

                    <tbody v-else class="divide-y divide-slate-200 border-b border-slate-200 text-sm">
                        <tr v-for="index in paging.perPage" :key="index" class="h-12">
                            <td
                                v-for="column in [{ id: 'extra' }, ...enabledColumns]"
                                :key="column.id"
                                class="bg-white whitespace-nowrap px-2"
                            >
                                <div class="h-5 w-full animate-pulse rounded bg-slate-200" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div
                v-if="showPagination"
                :class="{
                    'pointer-events-none opacity-25': !creators.length && !isLoading && paging.currentPage <= 1,
                }"
                class="border-t border-slate-200 px-3 py-2.5 w-full"
            >
                <DiscoveryPagination
                    :paging="paging"
                    :recordName="recordName"
                    :count-limit="countLimit"
                    page-size-label="Creators per page"
                    @paging-changed="onPagingChange"
                />
            </div>
        </template>
    </div>
</template>

<script>
import _ from 'lodash'
import { nextTick } from 'vue'
import { mapGetters } from 'vuex'
import Tooltip from '@/components/Tooltip.vue'
import DropdownTableHeader from '@/components/dropdowns/DropdownTableHeader.vue'
import DropdownMultiSort from '@/components/dropdowns/DropdownMultiSort.vue'
import DiscoveryPagination from '@/partials/tables/discovery/DiscoveryPagination.vue'
import ModalBasic from '@/components/ModalBasic.vue'

export default {
    name: 'DiscoverTable',

    components: {
        Tooltip,
        DropdownTableHeader,
        DropdownMultiSort,
        DiscoveryPagination,
        ModalBasic,
    },

    props: {
        creators: {
            type: Array,
            default: () => [],
        },
        type: {
            type: String,
        },
        isLoading: {
            type: Boolean,
        },
        isBusy: {
            type: Boolean,
        },
        isSelectable: {
            type: Boolean,
            default: () => false,
        },
        paging: {
            type: Object,
        },
        columns: {
            type: Array,
        },
        enabledColumns: {
            type: Array,
        },
        platformId: {
            type: String,
        },
        includeAllPlatformsByDefaultForList: {
            type: Boolean,
            default: () => false,
        },
        idProp: {
            type: String,
            default: () => '_id',
        },
        superviewPath: {
            type: String,
            default: () => 'superview',
        },
        listId: {
            type: String,
            default: () => null,
        },
        showPreGenerationSlot: {
            type: Boolean,
            default: () => false,
        },
        showPagination: {
            type: Boolean,
            default: () => true,
        },
        recordName: {
            type: String,
            default: () => null,
        },
        isSortable: {
            type: Boolean,
            default: () => true,
        },
        countLimit: {
            type: Number,
            default: () => null,
        },
    },

    emits: [
        'search-creators',
        'platform-select',
        'add-to-list',
        'add-to-campaign',
        'remove-from-list',
        'filter-change',
        'paging-change',
        'export-creators',
        'enabled-column-change',
        'send-email',
    ],

    data() {
        return {
            search: {
                text: '',
                platformId: 'twitch',
                platforms: [
                    {
                        id: 'twitch',
                        name: 'Twitch',
                    },
                    {
                        id: 'youtube',
                        name: 'YouTube',
                    },
                ],
            },

            fields: [],

            values: {
                searchText: '',
            },

            selectedCreators: {},

            state: {
                modals: {
                    addToListOrCampaign: {
                        isOpen: false,
                    },
                    removeFromList: {
                        isOpen: false,
                    },
                },
            },
        }
    },

    computed: {
        ...mapGetters([
            'getLanguageFromCode',
            'selfActiveOrganization',
            'isSfStaff',
            'isDevModeEnabled',
            'getFromDictionary',
            'checkPermission',
        ]),

        isInputValid() {
            if (!this.search.text) return false
            if (typeof this.search.text !== 'string') return false
            const trimmedSearchText = this.search.text.trim()
            if (!trimmedSearchText) return false
            if (trimmedSearchText.length < 2) return false
            return true
        },

        sortLookup() {
            return _.reduce(
                this.paging.sort,
                (result, sortEntry) => {
                    // eslint-disable-next-line no-param-reassign
                    result[sortEntry.field] = sortEntry.direction
                    return result
                },
                {},
            )
        },

        isAllPageCheckboxSelected() {
            if (this?.creators?.length === 0) return false

            return _.every(this.creators, (creator) => {
                return this.selectedCreators[creator[this.idProp]]
            })
        },

        visibleColumns() {
            // Create a map for quick lookup of column objects by id
            const columnsById = _.keyBy(this.columns, 'id')

            // Map through enabledColumns to preserve their order
            // and grab the corresponding column object for each enabled id
            return _.compact(this.enabledColumns.map(id => columnsById[id]))
        },

        sortColumns() {
            const sortLabelsById = {
                avg_viewers: 'Average viewers',
                sum_content_items: 'Total posts',
                followers: this.platformId === 'youtube' ? 'Total subscribers' : 'Total followers',
                avg_views: 'Average views',
                avg_likes: 'Average likes',
                avg_comments: 'Average comments',
                avg_shares: 'Average shares',
                avg_quotes: 'Average quotes',
                avg_engagement_rate: 'Engagement rate',
                account_rating_remapped: 'Content rating',
                age_range: 'Age range',
            }

            return _.compact(
                _.map(sortLabelsById, (label, id) => {
                    const column = _.find(this.columns, { id })

                    if (column?.header?.is_sortable !== true) {
                        return null
                    }

                    const sortColumn = _.cloneDeep(column)
                    sortColumn.header.label = label

                    return sortColumn
                }),
            )
        },
    },

    watch: {
        listId() {
            this.selectedCreators = {}
        },
    },

    methods: {
        scrollTableToTop() {
            this.$refs?.tableWrapper?.scrollTo({
                top: 0,
            })
        },

        onSelectCreator(creator) {
            if (!this.selectedCreators[creator[this.idProp]]) {
                this.selectedCreators[creator[this.idProp]] = creator
            } else {
                this.selectedCreators = _.omitBy(this.selectedCreators, (selectedCreator) => {
                    return selectedCreator[this.idProp] === creator[this.idProp]
                })
            }
        },

        onAllPageCheckboxClick() {
            const visibleCreatorsLookup = _.keyBy(this.creators, this.idProp)
            if (this.isAllPageCheckboxSelected === true) {
                this.selectedCreators = _.omitBy(this.selectedCreators, (selectedCreator) => {
                    const matchingCreator = visibleCreatorsLookup[selectedCreator[this.idProp]]
                    return matchingCreator
                })
            } else {
                _.forEach(this.creators, (creator) => {
                    const matchingCreator = this.selectedCreators[creator[this.idProp]]

                    if (!matchingCreator) {
                        this.selectedCreators[creator[this.idProp]] = creator
                    }
                })
            }
        },

        onHeaderColumnAction(columnId, actionId, actionData) {
            if (['sort-asc', 'sort-desc'].includes(actionId)) {
                // eslint-disable-next-line vue/no-mutating-props
                this.paging.sort = [
                    {
                        field: columnId,
                        direction: actionData,
                        source: 'user',
                    },
                ]

                // Emit the updated paging object so parent can refresh data
                this.$emit('filter-change', {
                    sort: this.paging.sort,
                    currentPage: 1, // Reset to first page when sorting changes
                })
            } else if (['sort-clear'].includes(actionId)) {
                // eslint-disable-next-line vue/no-mutating-props
                this.paging.sort = []

                // Emit the updated paging object so parent can refresh data
                this.$emit('filter-change', {
                    sort: [],
                    currentPage: 1, // Reset to first page when sorting changes
                })
            } else if (actionId === 'column-hide') {
                this.$emit(
                    'enabled-column-change',
                    _.filter(this.enabledColumns, (item) => item !== columnId),
                )
            }
        },

        // This is a full override of current sorting, coming from multi-sort
        onNewSort(newSort) {
            // eslint-disable-next-line vue/no-mutating-props
            this.paging.sort = newSort
            // Emit the updated paging object so parent can refresh data
            this.$emit('filter-change', {
                sort: newSort,
                currentPage: 1, // Reset to first page when sorting changes
            })
        },

        isColumnEnabled(column) {
            const isColumnInList = _.find(this.columns, (item) => item.key === column.key)
            return !!isColumnInList
        },

        debounceSearch: _.debounce(function () {
            nextTick(() => {
                if (this.isInputValid) {
                    this.$emit('search-creators', {
                        search: this.search.text,
                    })
                }
            })
        }, 500),

        onOptionsClose() {
            this.selectedCreators = {}
        },

        exportCreators() {
            this.$emit('export-creators', {})
        },

        onPagingChange(newPagingProperties) {
            this.$emit('paging-change', newPagingProperties)
            this.scrollTableToTop()
        },

        onColumnChange(newEnabledColumns) {
            this.$emit('enabled-column-change', newEnabledColumns)
        },

        onRemoveFromList() {
            this.$emit('remove-from-list', this.selectedCreators)
            this.state.modals.removeFromList.isOpen = false
            this.selectedCreators = {}
        },

        async onSendEmail() {
            if (this.listId) {
                const recipients = await this.createListEmailRecipients()
                this.$emit('send-email', recipients)
            }
        },

        async createListEmailRecipients() {
            const creatorsToCheckEmails = _.map(this.selectedCreators, creator => {
                 return ['superview', creator.platform_id, creator.id]
            })

            await this.$store.dispatch('bulkReveal', { quotaType: 'profile-unlock', items: creatorsToCheckEmails})

            return _.map(this.selectedCreators, (selectedCreator) => {
                const unlockState = this.$store.getters.unlocks[`profile-unlock:superview:${selectedCreator.platform_id}:${selectedCreator.id}`]
                let creatorEmail = null

                if (unlockState.value?.email && ((unlockState.unlock && unlockState.is_previously_unlocked) || unlockState.value?.source === 'self' || (unlockState.value?.source === 'streamforge' && this.$store.getters.isSfStaff === true))) {
                    creatorEmail = unlockState.value.email
                }

                return {
                    creator_name:
                        selectedCreator?.superview?.normalized.display_name ||
                        selectedCreator?.partialview?.normalized.display_name ||
                        selectedCreator?.superview?.normalized.name ||
                        selectedCreator?.partialview?.normalized.name ||
                        'Unknown Creator',
                    email: creatorEmail,
                }
            })
        },

    },
}
</script>
